<template>
  <div>
    <modal-config-canchas
      :listCategorias="[]"
      :listConfiguraciones="[]"
      :showLoading="false"
      :isCreando="false"
      :listDias="[]"
      :listCanchas="listCanchas"
      :listCanchasBD="listCanchasBaseDatos"
      :historialSeleccionado="historialSeleccionado"
      @errorCanchas="errorCanchas"
      @exitoCanchas="exitoCanchas"
    ></modal-config-canchas>
    <b-card no-body class="p-1">
      <b-row>
        <b-col md="3">
          <v-select
            :options="listHistoriales"
            @input="changeHistorial"
            placeholder="Selecciona Historial"
            :clearable="false"
            v-model="historialSeleccionado"
          />
        </b-col>
        <b-col md="4">
          <v-select
            v-if="historialSeleccionado.value !== null"
            :options="historialSeleccionado.auditoria"
            @input="changeAuditoria"
            placeholder="Seleccione Generacion"
            :clearable="false"
            v-model="auditoriaSeleccionada"
          /> </b-col
      ></b-row>
    </b-card>
    <b-overlay :show="showLoadingContenido" rounded="sm">
      <programaciones
        v-if="auditoriaSeleccionada.value !== null"
        :dias="listDias"
        :franjas="listFranjas"
        :partidos="listPartidos"
      ></programaciones>
    </b-overlay>
    <b-row class="mt-1">
      <b-col md="4" style="margin-top:18px">
        <b-form-datepicker
          v-if="
            auditoriaSeleccionada.value !== null &&
              historialSeleccionado.canchas_asignacion.length > 0
          "
          :date-disabled-fn="dateDisabled"
          @input="getDataFechas"
          placeholder="Seleccione la semana a programar"
          v-model="fechaPartido"
      /></b-col>
      <b-col v-if="auditoriaSeleccionada.value !== null" md="8" class="m-0 p-0">
        <b-button
          v-if="
            USER().rol === ROLES.SUPER ||
              USER().rol === ROLES.ADMIN ||
              USER().rol === ROLES.TECNICA
          "
          v-b-tooltip.hover.v-primary
          title="Asignar canchas a los partidos programados"
          variant="flat-primary"
          class="btn-icon"
          @click="openConfigCanchas"
        >
          <feather-icon size="15" icon="LayersIcon" />
        </b-button>
        <span style="font-size:11px;font-weight: bolder;"
          >Canchas Asignadas: <br
        /></span>
        <span
          class="cancha"
          v-for="cancha in historialSeleccionado.canchas_asignacion"
          :key="cancha.id_cancha_horario"
        >
          ({{ cancha.id_cancha_horario }}) {{ cancha.label }}
        </span>
      </b-col>
      <b-col md="12"> </b-col>
    </b-row>
    <div
      v-if="!showLoadingSaveHorarios"
      style="text-align:center; margin-top:20px"
    >
      <b-button
        v-if="
          (USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.TECNICA) &&
            fechaPartido !== '' &&
            historialSeleccionado.canchas_asignacion.length > 0
        "
        @click="saveHorarios"
        variant="warning"
      >
        Guardar Horarios con la fecha seleccionada
      </b-button>
    </div>
    <div v-if="showLoadingSaveHorarios" class="text-center mt-1">
      <b-spinner variant="primary" label="Text Centered" />
    </div>
    <div style="width:100%; height:20px"></div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  //   BTabs,
  //   BTab,
  BCard,
  BRow,
  BCol,
  BFormDatepicker,
  BButton,
  VBTooltip,
  BSpinner,
  BOverlay,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'
import {
  URL,
  USER,
  ROLES,
  //   DISCIPLINAS,
  // ACTION_INSERT
} from '../../utils/variables'

import Programaciones from './Programaciones.vue'
import apiCall from '../../utils/apiCall'
import ModalConfigCanchas from './ModalConfigCanchas.vue'

const moment = require('moment-timezone')

export default {
  components: {
    BCard,
    vSelect,
    BRow,
    BCol,
    Programaciones,
    BFormDatepicker,
    BButton,
    ModalConfigCanchas,
    BSpinner,
    BOverlay,
  },
  props: {
    listHistoriales: Array,
    refresh: Number,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup(props, { emit }) {
    const { getApi, postApi } = apiCall()
    const listDias = ref([{ dia: '' }])
    const listFranjas = ref([{ hora: '' }])
    const listPartidos = ref({})
    const fechaPartido = ref('')
    const listCanchas = ref([])
    const listCanchasBaseDatos = ref([])
    const idDisciplina = ref(null)
    const auxiliarDias = ref([])
    const showLoadingSaveHorarios = ref(false)
    const showLoadingContenido = ref(false)

    const historialSeleccionado = ref({
      label: 'Seleccione Historial',
      value: null,
      canchas_asignacion: [],
      auditoria: [],
    })
    const auditoriaSeleccionada = ref({
      label: 'Seleccione generacion',
      value: null,
    })
    function changeHistorial() {
      listDias.value = [{ dia: '' }]
      listFranjas.value = [{ hora: '' }]
      listPartidos.value = {}
      listCanchas.value = []
      showLoadingContenido.value = false
      fechaPartido.value = ''
      auditoriaSeleccionada.value = {
        label: 'Seleccione generacion',
        value: null,
      }
    }
    const getCanchasBD = async () => {
      const path = `ApiConfiguration/getUtilsCanchas/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}/${idDisciplina.value}`
      const data = await getApi(URL, path)
      listCanchasBaseDatos.value = data
    }
    function openConfigCanchas() {
      getCanchasBD()
      store.commit('someVariables/UPDATE_SHOW_MODAL_CANCHAS', true)
    }
    function getArrayWeek(weekStart) {
      const arrayDias = []
      auxiliarDias.value = []
      for (let i = 0; i <= 6; i += 1) {
        const day = moment(weekStart)
          .add(i, 'days')
          // eslint-disable-next-line
          .format('YYYY-MM-DD')
        arrayDias.push(day)
        auxiliarDias.value.push(day.substring(8, 10))
        // console.log(`dias ${day}`)
      }
      return arrayDias
    }
    const mapaAsignaciones = {}

    function asignarCanchasReales(partidosPorDia) {
      historialSeleccionado.value.canchas_asignacion.forEach(a => {
        mapaAsignaciones[a.id_cancha_horario] = a.id_cancha_real
      })
      Object.keys(partidosPorDia).forEach(dia => {
        const horas = partidosPorDia[dia]

        Object.keys(horas).forEach(hora => {
          const canchas = horas[hora]

          Object.keys(canchas).forEach(id => {
            const partido = canchas[id]

            const idHorario = String(partido.id_cancha_horario)

            if (mapaAsignaciones[idHorario]) {
              partido.id_cancha_real = mapaAsignaciones[idHorario]
            }
          })
        })
      })

      return partidosPorDia
    }
    function obtenerAsignacionesPlanas(partidosPorDia) {
      const resultado = []

      Object.keys(partidosPorDia).forEach(dia => {
        const horas = partidosPorDia[dia]

        Object.keys(horas).forEach(hora => {
          const canchas = horas[hora]
          // console.log(hora)

          Object.keys(canchas).forEach(id => {
            const partido = canchas[id]

            if (partido) {
              resultado.push({
                id_partido: partido.id_partido, // ⚠️ asegúrate que exista
                fecha: partido.fecha,
                id_cancha_real: partido.id_cancha_real,
                hora_enviar: hora,
              })
            }
          })
        })
      })
      // console.log(resultado)
      return resultado
    }
    async function saveHorarios() {
      if (fechaPartido.value === '') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ERROR, DEBES SELECCIONAR UNA FECHA',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
        return
      }
      const data = {
        // dias: props.listDias,
        partidos: obtenerAsignacionesPlanas(listPartidos.value),
        idUsuario: USER().id_usuario,
        dataMovimiento: `Publica horarios para la semana del ${fechaPartido.value} usando generación (${auditoriaSeleccionada.value.label})`,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      showLoadingSaveHorarios.value = true
      // console.log(data)
      const path = 'ApiFixture/updateHorariosDesdeGenerador'
      const response = await postApi(URL, path, data)
      if (response.flag === 'no') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: response.mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'HORARIOS PUBLICADOS CON EXITO',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
      }
      showLoadingSaveHorarios.value = false
      fechaPartido.value = ''
      // console.log(response)
    }
    function errorCanchas() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ERROR, HAY CANCHAS REPETIDAS',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    function exitoCanchas() {
      emit('exitoCanchas', historialSeleccionado.value.value)
      historialSeleccionado.value = {
        label: 'Seleccione Historial',
        value: null,
        canchas_asignacion: [],
        auditoria: [],
      }
      listPartidos.value = {}
      listDias.value = []
      listFranjas.value = []
      auditoriaSeleccionada.value = {
        label: 'Seleccione generacion',
        value: null,
      }

      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title:
              'EXITO, porfavor selecciona nuevamente el historial y generacion para ver las canchas asignadas',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    const diasMap = {
      LUNES: 0,
      MARTES: 1,
      MIERCOLES: 2,
      JUEVES: 3,
      VIERNES: 4,
      SABADO: 5,
      DOMINGO: 6,
    }
    function agregarFechas(partidosPorDia, fechas) {
      Object.keys(partidosPorDia).forEach(dia => {
        const index = diasMap[dia]
        const fecha = fechas[index]

        const horas = partidosPorDia[dia]

        Object.keys(horas).forEach(hora => {
          const canchas = horas[hora]

          Object.keys(canchas).forEach(idCancha => {
            const partido = canchas[idCancha]

            // 🔥 aquí agregas la fecha
            partido.fecha = fecha
          })
        })
      })

      return partidosPorDia
    }
    function getDataFechas() {
      const currentDate = moment(fechaPartido.value)
      const weekStart = currentDate.clone().startOf('isoWeek')
      const arrayDias = getArrayWeek(weekStart)
      agregarFechas(listPartidos.value, arrayDias)
      asignarCanchasReales(listPartidos.value)
      // console.log(arrayDias)
      // console.log(listPartidos.value)
      // fechas.value = arrayDias
    }
    function dateDisabled(ymd, date) {
      const weekday = date.getDay()
      return (
        weekday === 0 ||
        weekday === 2 ||
        weekday === 3 ||
        weekday === 4 ||
        weekday === 5 ||
        weekday === 6
      )
    }
    watch(
      () => props.refresh,
      () => {
        // console.log('refres')
        historialSeleccionado.value = {
          label: 'Seleccione Historial',
          value: null,
          canchas_asignacion: [],
          auditoria: [],
        }
        changeHistorial()
      },
    )
    const changeAuditoria = async () => {
      showLoadingContenido.value = true
      const path = `ApiConfiguration/getPartidosPorGeneracion/${auditoriaSeleccionada.value.value}/${historialSeleccionado.value.value}`
      const data = await getApi(URL, path)
      listDias.value = data.dias
      listFranjas.value = data.horas
      listPartidos.value = data.partidos
      listCanchas.value = data.canchas
      idDisciplina.value = data.id_disciplina
      showLoadingContenido.value = false
      // console.log(listCanchas)
    }
    return {
      changeHistorial,
      changeAuditoria,
      historialSeleccionado,
      auditoriaSeleccionada,
      listDias,
      listFranjas,
      listPartidos,
      dateDisabled,
      fechaPartido,
      USER,
      ROLES,
      openConfigCanchas,
      listCanchas,
      listCanchasBaseDatos,
      getDataFechas,
      obtenerAsignacionesPlanas,
      saveHorarios,
      errorCanchas,
      exitoCanchas,
      showLoadingSaveHorarios,
      showLoadingContenido,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.cancha {
  background: lightskyblue;
  padding: 5px;
  border-radius: 5px;
  color: black;
  font-size: 9px;
  font-weight: bolder;
  text-transform: uppercase;
  margin-right: 4px;
}
</style>
